export function getFirstDayOfWeek(date: Date) {
  const d = new Date(date);
  const dayOfWeek = d.getDay();
  const diff = d.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Obliczamy różnicę dni, aby uzyskać pierwszy dzień tygodnia
  return new Date(d.setDate(diff));
}
